import(/* webpackMode: "eager" */ "/vercel/path0/app/venues/page.tsx");
